import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID,
  ViewEncapsulation
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResigteringService } from '../auth/resigtering.service';
import Swal from 'sweetalert2';
import { LoginService } from '../auth/login.service';
import { DeviceDetectorService } from '../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-resigtering',
  templateUrl: './resigtering.component.html',
  styleUrl: './resigtering.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class ResigteringComponent implements OnInit {

  formInfo!: FormGroup;
  contentReady = false;

  isPasswordVisible = false;
  isUpdatePage = false;
  editedUserId: any;

  isMobile = false;
  isAr = false;
  private isBrowser: boolean;

  accessPages: number[] = [];

  constructor(
    private fb: FormBuilder,
    private registerService: ResigteringService,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private deviceService: DeviceDetectorService,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.initForm();

    if (!this.isBrowser) return;

    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') === 'ar';

    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.isUpdatePage = true;
        this.editedUserId = params['id'];
      }

      if (params['access_pages']) {
        this.accessPages = JSON.parse(params['access_pages']).map(Number);
      }
    });
  }

  private initForm(): void {
    this.formInfo = this.fb.group(
      {
        name: ['', [Validators.required, Validators.minLength(3)]],
        sname: ['', [Validators.required, Validators.minLength(3)]],
        phone: ['', [Validators.required, Validators.pattern(/^\d{11}$/)]],
        password: ['', [Validators.required, Validators.minLength(8)]],
        c_Password: ['', Validators.required],
      },
      { validators: this.passwordsMatch }
    );
  }

  passwordsMatch(group: FormGroup) {
    const pass = group.get('password')?.value;
    const confirm = group.get('c_Password');
    if (confirm && pass !== confirm.value) {
      confirm.setErrors({ mismatch: true });
    } else {
      confirm?.setErrors(null);
    }
    return null;
  }

  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  onSubmit(): void {
    if (this.formInfo.invalid) return;

    this.contentReady = true;
    const fv = this.formInfo.value;

    const formData = new FormData();
    formData.append('first_name', fv.name);
    formData.append('last_name', fv.sname);
    formData.append('username', fv.phone);
    formData.append('phone', fv.phone);
    formData.append('password', fv.password);
    formData.append('password_confirmation', fv.c_Password);
    formData.append('type', '9');
    formData.append('access_pages', JSON.stringify(this.accessPages));

    const request$ = this.isUpdatePage
      ? this.registerService.editUser(this.editedUserId, formData)
      : this.registerService.user_Resigter(formData);

    request$.subscribe({
      next: (res) => {
        this.contentReady = false;

        Swal.fire({
          icon: 'success',
          title: this.isAr ? 'تم الحفظ بنجاح' : 'Saved successfully',
          timer: 1500,
          showConfirmButton: false,
        });

        this.router.navigate(['/Home']);
      },
      error: () => {
        this.contentReady = false;
        Swal.fire({
          icon: 'error',
          title: this.isAr ? 'حصل خطأ' : 'Something went wrong',
          confirmButtonText: this.isAr ? 'حسناً' : 'OK',
        });
      }
    });
  }
}
